import _objectSpread from "F:/vue2.0+ vant/2024\u5E74\u9879\u76EE\u96C6\u5408/\u5143\u7FBF\u5B98\u7F51\u9879\u76EE\u96C6\u5408/\u5143\u7FBF\u4E2D\u6587\u7248\u672C/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "F:/vue2.0+ vant/2024\u5E74\u9879\u76EE\u96C6\u5408/\u5143\u7FBF\u5B98\u7F51\u9879\u76EE\u96C6\u5408/\u5143\u7FBF\u4E2D\u6587\u7248\u672C/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.map.js";
import { ref, reactive, onMounted, computed } from 'vue';
import { getHomeTopMediaReportsList_url } from '@/api'; //引入发送请求获取数据的方法

import { useRouter, useRoute } from 'vue-router';
export default {
  name: 'Manage',
  setup: function setup() {
    var reportsList = ref([]); //获取媒体报道前三个

    function getHomeTopMediaReportsList() {
      return _getHomeTopMediaReportsList.apply(this, arguments);
    }

    function _getHomeTopMediaReportsList() {
      _getHomeTopMediaReportsList = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var result;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return getHomeTopMediaReportsList_url();

              case 2:
                result = _context.sent;

                if (result.code == 200) {
                  reportsList.value = result.data.reportsList.map(function (report) {
                    return _objectSpread(_objectSpread({}, report), {}, {
                      // 复制当前对象，保持其他属性不变  
                      // publishDate: report.publishDate.substring(5), // 截取字符串从第6个字符开始到结束，即"YYYY-MM-DD"变为"MM-DD"  
                      publishDate: report.publishDate // 截取字符串从第6个字符开始到结束，即"YYYY-MM-DD"变为"MM-DD"  
                      // 或者使用更健壮的日期处理方式（推荐）)

                    });
                  }); // console.log('reportsList=', result.reportsList)
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _getHomeTopMediaReportsList.apply(this, arguments);
    }

    onMounted(function () {
      getHomeTopMediaReportsList(); //获取媒体报道列表
    });
    var router = useRouter();
    var route = useRoute();

    var jumpMedia = function jumpMedia() {
      router.push('/report');
    };

    var jumpMediaDetail = function jumpMediaDetail(item) {
      if (item.jumpFlag == 1) {
        var url = item.jumpUrl;
        window.open(url);
      } else {
        router.push({
          path: '/mediaDetails',
          query: {
            reportId: item.reportId
          }
        });
        return;
      }
    };

    return {
      reportsList: reportsList,
      jumpMedia: jumpMedia,
      jumpMediaDetail: jumpMediaDetail
    };
  }
};